import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Mtech_curriculumEle from './Mtech_curriculumEle'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Curriculum"/>
        <Mtech_curriculumEle />
      </>
    )
  }
  
  export default Main